


































































































































































































































































































import { Component, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import VueSlider from "vue-slider-component";
import ChoiceFactorDateTime from "@/components/choice-input/ChoiceFactorInputDateTime.vue";
import moment from "moment";
import _ from "lodash";

@Component({
    components: {VueSlider, ChoiceFactorDateTime}
})
export default class DateTimeScoringDefinitionRuleCreator extends Vue {

    @Model()
    scoringRules!: any[];

    @Prop()
    scoringKeys!: any[];

    @Prop()
    values!: string[];

    @Prop()
    dateFormat!: string;

    @Prop()
    prefix!: string;

    @Prop()
    suffix!: string;

    @Prop()
    tab: number


    private menu = [];
    private dates = [];
    private storedDates = [];
    private textInputValues: string[] = [];

    private datePicker = false;
    
    private inverted: boolean = false;
    private roundUpperLimit: boolean = false;

    private maxDate = new Date().toISOString().slice(0,10);
    private minDate = new Date().toISOString().slice(0,10);

    private maxMenu = false;
    private minMenu = false;
    private incrementDisplay = 0;
    private areDatesInOrder = true;

    private rules = {
        number: (value) => typeof value==='number' || 'Not valid number',
        order: (value) => value ? true: "Not in order"
    };

    get isInverted() {
        return this.inverted;
    }

    get formattedMaxValue() {
        return moment(this.maxDate).format(this.dateFormat);
    }

    get formattedMinValue() {
        return moment(this.minDate).format(this.dateFormat);
    }

    get maxValue() {
        return moment(this.maxDate).valueOf()
    }

    get minValue() {
        return moment(this.minDate).valueOf()
    }

    get formattedDates() {
        return this.dates.map((date: string)=> moment(date).format(this.dateFormat));

    }

    private isVisible(index:any) {
        return this.menu[index]
    }

    mounted() {
        this.menu.fill(false, 0, this.scoringKeys.length)
        setTimeout(() => { this.incrementDisplay++}, 200);
        if (this.values && this.values.length > 0) {
            this.maxDate = this.values.reduce((a, b) => moment.max(moment(a), moment(b)).format(this.dateFormat))
            this.minDate = this.values.reduce((a, b) => moment.min(moment(a), moment(b)).format(this.dateFormat))
        }

        
        if (this.scoringRules.length > 0) {
            if (this.scoringRules.filter(sr => sr.scoringFunction === 'MANUAL').length) {
                while (this.scoringRules.length !== 0) {
                    this.scoringRules.splice(0, 1)
                }
                this.initializeScoringRules();

            } else {
                // while (this.scoringKeys.length !== 0) {
                //     this.scoringKeys.splice(0, 1)
                // }
                this.dates.splice(0, this.dates.length);
                let maxUnix= Math.max(...this.scoringRules.map(sr => sr.upperLimit))
                let minUnix = Math.min(...this.scoringRules.map(sr => sr.lowerLimitExclusive))

                this.maxDate = moment(maxUnix).format(this.dateFormat);
                this.minDate = moment(minUnix).format(this.dateFormat)

                for (let index = 1; index < this.scoringRules.length; index++) {
                    let scoringRule = this.scoringRules[index];
                    // this.scoringKeys.splice(this.scoringKeys.length, 0, scoringRule.scoringKey);
                    let inputValue = moment(scoringRule.upperLimit).format(this.dateFormat);

                    // if(moment(scoringRule.upperLimit).isAfter(moment(this.maxDate)))
                    //     this.maxDate = moment(scoringRule.upperLimit).format(this.dateFormat)

                    // if(moment(scoringRule.lowerLimitExclusive).isBefore(moment(this.minDate)))
                    //     this.minDate = moment(scoringRule.lowerLimitExclusive).format(this.dateFormat)
                    if (scoringRule.inverted) {
                        this.inverted = true;
                    }
                    if(scoringRule.roundUpperLimit) {
                        this.roundUpperLimit = true;
                    }
                    this.dates.splice(this.dates.length, 0, inputValue);
                }
                if(this.inverted) {
                    this.storedDates.sort((a: any, b: any) => (this.convertToScoringRuleValue(a) - this.convertToScoringRuleValue(b)))
                    this.dates.sort((a: any, b: any) => (this.convertToScoringRuleValue(a) - this.convertToScoringRuleValue(b)))
                }
            }
        } else {
            this.minDate = moment(this.maxDate).subtract(this.scoringKeys.length, 'months').format(this.dateFormat)
            let interval = moment(this.maxDate).diff(moment(this.minDate)).valueOf() / this.scoringKeys.length
            console.log(this.dates)
            for(let i = 0; i < this.scoringKeys.length-1; i++) {
                this.dates[i] = moment(this.maxDate).subtract(interval * (i+1)).format(this.dateFormat)
                this.storedDates[i] =  moment(this.dates[i]).valueOf()
            }
        
            this.initializeScoringRules()
        }
    }

    private initializeScoringRules() {
        let unixMinDate = moment(this.minDate).valueOf()
        let unixMaxDate = moment(this.maxDate).valueOf()
        let interval = moment(this.maxDate).diff(moment(this.minDate)).valueOf() / this.scoringKeys.length
        //Clear scoring rules on init
        this.scoringRules.splice(0, this.scoringRules.length);
         
        for (let index = 0; index < this.scoringKeys.length; index++) {
            let upperLimit;
            let lowerLimitExclusive
            if (index === 0) {
                upperLimit = this.maxValue;
                lowerLimitExclusive = unixMaxDate - interval;
            } else if (index === this.scoringKeys.length - 1) {
                upperLimit = unixMinDate + interval;
                lowerLimitExclusive = unixMinDate;
            } else {
                upperLimit = unixMaxDate- (interval * (index))
                lowerLimitExclusive = unixMaxDate - (interval * (index + 1))
            }
            let inputValue = upperLimit;
            if (this.isInverted) {
                inputValue = unixMaxDate + unixMinDate - inputValue;
            }
            this.textInputValues.splice(this.textInputValues.length, 0, inputValue);
            let scoringRule = {
                upperLimit: upperLimit,
                lowerLimitExclusive: lowerLimitExclusive,
                inverted: this.isInverted,
                scoringFunction: 'LINEAR',
                scoringKey: this.scoringKeys[index]
            }
            this.scoringRules.splice(this.scoringRules.length, 0, scoringRule);
        }
    }

    /**
     * Updates various values based on the range values changing
     */
    private submitRangeChange() {
        if(moment(this.minDate).isAfter(moment(this.maxDate)) || this.inverted) {
            this.updateScoringRules(); 

        } else {
             if (this.storedDates.length > 0 && !moment(this.storedDates[0]).isSame(moment(this.maxDate))) {
                //Max value has been changed, update it
            //    this.storedDates[0] = this.convertToScoringRuleValue(this.maxDate);
            //    this.dates[0] = this.maxDate
                this.updateScoringRules();
            } else if (this.storedDates.length > 0 && moment(this.storedDates[this.storedDates.length - 1]).isBefore(moment(this.minDate))) {
                //Min value changed
            //    this.storedDates[this.storedDates.length - 1] = this.convertToScoringRuleValue(this.minDate);
            //    this.dates[this.dates.length - 1] = this.minDate
                this.initializeScoringRules();
                this.updateScoringRules(); 
            }  else if (this.storedDates.length > 0 && this.storedDates[0] > this.convertToScoringRuleValue(this.maxDate)) {
                //Min value is smaller than the smallest scoring rule lower limit, update it
            //    this.storedDates[0] = this.convertToScoringRuleValue(this.maxDate);
            //    this.dates[0] = this.maxDate;

                this.updateScoringRules(); 
            }   
        }
    }

    private changeTextInputField(index: number) {
        if (!this.dates[index]) {
            return;
        }
        let tempAreValuesInOrder = true;
        for(let i = 0; i < this.textInputValues.length-1; i++) {
            if(moment(this.textInputValues[i]).isBefore(moment(this.textInputValues[i+1])))
            tempAreValuesInOrder = false
        }
        this.areDatesInOrder = tempAreValuesInOrder;

        this.updateScoringRules()
    }

    private updateScoringRules() {
        let rulesArray = [this.convertToScoringRuleValue(this.maxDate)].concat(this.storedDates, this.convertToScoringRuleValue(this.minDate))
        for (let index = 0; index < this.scoringRules.length; index++) {
            Vue.set(this.scoringRules[index], 'upperLimit', this.convertToScoringRule(rulesArray[index]));
            if (index !== this.scoringRules.length - 1) {
                Vue.set(this.scoringRules[index], 'lowerLimitExclusive', this.convertToScoringRule(rulesArray[index + 1]));
            } else {
                Vue.set(this.scoringRules[index], 'lowerLimitExclusive', this.convertToScoringRuleValue(this.minDate));
            }
            Vue.set(this.scoringRules[index], 'inverted', this.inverted);
            Vue.set(this.scoringRules[index], 'roundUpperLimit', this.roundUpperLimit);
        }
    }

    private invertedChanged() {
       if(this.inverted) {
            this.storedDates.sort((a: any, b: any) => (this.convertToScoringRuleValue(a) - this.convertToScoringRuleValue(b)))
            this.dates.sort((a: any, b: any) => (this.convertToScoringRuleValue(a) - this.convertToScoringRuleValue(b)))

        } else {
            this.storedDates.sort((a: any, b: any) => (this.convertToScoringRuleValue(b) - this.convertToScoringRuleValue(a)))
            this.dates.sort((a: any, b: any) => (this.convertToScoringRuleValue(b) - this.convertToScoringRuleValue(a)))

        }
        this.updateScoringRules();
      
    }

    private convertToScoringRuleValue(value: string) {
        return moment(value).valueOf()
    }

    private convertToScoringRule(value: any) {
        // if(this.inverted) {
        //     return moment(this.maxDate).valueOf() - moment(value).valueOf() + moment(this.minDate).valueOf()
        // }
        // else
            return moment(value).valueOf()
    }

    
    @Watch('dates', {deep: true})
    private onValueChange(newVal, oldVal) {
        if(_.isEqual(newVal, oldVal)) {
            this.storedDates = this.dates.map((date: string)=> moment(date).format(this.dateFormat).valueOf());
            this.updateScoringRules();
        }
    }

    private getFormattedDate(date: any) {
        let tempAreValuesInOrder = true;
        if(this.inverted) {
            for(let i = 0; i < this.dates.length-1; i++) {
                if(moment(this.dates[i]).isAfter(moment(this.dates[i+1]))) {
                    tempAreValuesInOrder = false
                    console.log(tempAreValuesInOrder)
                }
            }
        } else {
            for(let i = 0; i < this.dates.length-1; i++) {
                if(moment(this.dates[i]).isBefore(moment(this.dates[i+1]))) {
                    tempAreValuesInOrder = false
                }
            }
        }
        this.areDatesInOrder = tempAreValuesInOrder;
        return moment(date).format(this.dateFormat)
    }

    @Watch('maxDate')
    private onMaxChange(newVal, oldVal) {
        if(newVal != oldVal)
            this.submitRangeChange()
    }

    @Watch('minDate')
    private onMinChange(newVal, oldVal) {
        if(newVal != oldVal)
            this.submitRangeChange()
    }

    @Watch('tab')
    private onChangeTab(){
        if(this.tab === 1 && this.scoringRules.length === 0){
            this.initializeScoringRules()
        }
    }
}
